import React from "react";
import Logo from "../assets/icons/LogoWhite";
import { Link } from "react-router-dom";
import Appstore from "../assets/icons/AppIcon";
import Googleplay from "../assets/icons/Googleplay";
import Insta from "../assets/icons/Insta";
import Facebook from "../assets/icons/Facebook";
import Youtube from "../assets/icons/Youtube";
import Twitter from "../assets/icons/Twitter";
// import Linkedin from "../assets/icons/Linkedin";
import X from "../assets/icons/X";
import { useTranslation } from "react-i18next";
import LinkedIn from "../assets/icons/LinkedIn";

const Footer = () => {
  const { t } = useTranslation();
  const handleClick = () => {
    window.open("https://appcarpenter.com", "_blank"); // Open link in a new tab
  };
  const redirectToApp = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      window.location.href = "https://apple.com/in/app-store/";
    } else if (userAgent.includes("android")) {
      window.location.href = "https://play.google.com/store/apps/";
    } else if (
      userAgent.includes("macintosh") ||
      userAgent.includes("macos") ||
      userAgent.includes("macbook")
    ) {
      window.location.href = "https://apple.com/in/app-store/";
    } else if (userAgent.includes("windows") || userAgent.includes("linux")) {
      window.location.href = "https://play.google.com/store/apps/";
    } else {
      window.location.href = "/";
    }
  };

  return (
    <footer className="hr_footer">
      <div className="wrapper">
        <div className="hr_ft_first">
          <Link to="/" className="logo">
            <Logo />
          </Link>
          {/* <div className="ft_btn_flex">
            <div className="ft_social_btn" onClick={redirectToApp}>
              <Appstore />
            </div>
            <div className="ft_social_btn" onClick={redirectToApp}>
              <Googleplay />
            </div>
          </div> */}
        </div>

        <div className="hr_grid_section">
          <div className="hr_grd_custom">
            <p className="hr_grd_heading">{t("about_loadInn")}</p>
            <ul>
              <li>
                <Link to="/about-us">{t("who_we_are")}</Link>
              </li>
              <li>
                <Link to="/why-us">{t("why_choose_us")}</Link>
              </li>
              <li>
                <Link to="/contact">{t("contact_us")}</Link>
              </li>
            </ul>
          </div>
          {t("")}
          <div className="hr_grd_custom">
            <p className="hr_grd_heading">{t("earning")}</p>
            <ul>
              <li>
                <Link to="/add-restaurant">
                  {t("become_restaurant_partner")}
                </Link>
              </li>
              <li>
                <Link to="/delivery-partner">
                  {t("become_delivery_partner")}
                </Link>
              </li>
            </ul>
          </div>
          <div className="hr_grd_custom">
            <p className="hr_grd_heading">{t("terms_and_conditions")}</p>
            <ul>
              <li>
                <Link to="/privacy-policy">{t("privacy_policy")}</Link>
              </li>
              <li>
                <Link to="/terms">{t("terms")}</Link>
              </li>
              {/* <li>
                <Link to="#">{t("sitemap")}</Link>
              </li> */}
            </ul>
          </div>
          <div className="hr_grd_custom">
            <p className="hr_grd_heading">{t("stay_connected_with_us")}</p>
            <p className="des_drd">
              {t("get_the_latest_updates_by_following_us_online")}
            </p>
            <div className="social_link">
              <Link to="https://www.instagram.com/loadinn.lv" target="_blank">
                <Insta />
              </Link>
              <Link
                to="https://www.facebook.com/people/Loadinn/61583238120833/?mibextid=wwXIfr&rdid=RfjXUeljSTu9H1Xe&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14NQ1ozD28p%2F%3Fmibextid%3DwwXIfr"
                target="_blank"
              >
                <Facebook />
              </Link>
              <Link to="#" target="_blank">
                <LinkedIn />
              </Link>
              {/* <Link to="https://www.linkedin.com/company/loadinn-o%C3%BC/" target="_blank">
                <Linkedin />
              </Link> */}
            </div>
          </div>
        </div>

        <div className="hr_copyright">
          <span>
            {t("copyright_all_right_reserved_created_by")}{" "}
            <span
              onClick={handleClick}
              style={{
                cursor: "pointer",
                color: "#8B4513",
                fontWeight: "bold",
              }}
            >
              {/* AppCarpenter */}
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
